interface ManifestRecord {
  OrderLineId: string;
  SmartSendId: string;
  ProviderId: string;
  AccountId: string;
  ManifestId: string;
}

export type RefundRecord = { orderlineId: string; amount: number; status: string; created?: Date };

export type ClaimRecord = { id?: string; orderlineId: string; status: string; created?: Date };

interface ExtendedOrderCacheType {
  refundOrderLineIds: RefundRecord[];
  claimOrderLineIds: ClaimRecord[];
  supportOrderLineIds: {
    id: string;
    orderlineId: string;
    status: 'Pending Customer' | 'Pending Customer Warned' | string;
  }[];
  recentlyBookedSmartSendItems: string[];
  manifestedOrderLineIds: ManifestRecord[];
  preManifestedOrderLineIds: ManifestRecord[];
}

export const ExtendedOrderCache: ExtendedOrderCacheType = {
  refundOrderLineIds: [],
  claimOrderLineIds: [],
  supportOrderLineIds: [],
  recentlyBookedSmartSendItems: [],
  manifestedOrderLineIds: [],
  preManifestedOrderLineIds: []
};

export const GetRefundForOrderLineId = (orderLineId?: string | number | null): RefundRecord | undefined => {
  if (orderLineId == null) {
    return undefined;
  }
  const key = orderLineId.toString();
  return ExtendedOrderCache.refundOrderLineIds.find((x) => x.orderlineId.toString() === key);
};

export const GetRefundsForOrderLineId = (orderLineId?: string | number | null): RefundRecord[] => {
  if (orderLineId == null) {
    return [];
  }
  const key = orderLineId.toString();
  return ExtendedOrderCache.refundOrderLineIds.filter((x) => x.orderlineId.toString() === key);
};

export const GetClaimForOrderLineId = (orderLineId?: string | number | null): ClaimRecord | undefined => {
  if (orderLineId == null) {
    return undefined;
  }
  const key = orderLineId.toString();
  return ExtendedOrderCache.claimOrderLineIds.find((x) => x.orderlineId.toString() === key);
};

export const GetClaimsForOrderLineId = (orderLineId?: string | number | null): ClaimRecord[] => {
  if (orderLineId == null) {
    return [];
  }
  const key = orderLineId.toString();
  return ExtendedOrderCache.claimOrderLineIds.filter((x) => x.orderlineId.toString() === key);
};
